module.exports = __webpack_public_path__ + "static/media/galerija_2021 (28).d4bb3e7a.jpg";